/*
 * Copyright (c) 2024-2026, s0up and the autobrr contributors.
 * SPDX-License-Identifier: GPL-2.0-or-later
 */

export type Accent = "blue" | "teal" | "amber" | "graphite";

const ACCENT_KEY = "nyrvex-accent";
const ACCENTS: Accent[] = ["blue", "teal", "amber", "graphite"];

export function getAccent(): Accent {
  try {
    const v = localStorage.getItem(ACCENT_KEY) as Accent | null;
    return v && ACCENTS.includes(v) ? v : "blue";
  } catch {
    return "blue";
  }
}

export function setAccent(accent: Accent): void {
  try {
    localStorage.setItem(ACCENT_KEY, accent);
  } catch {
    /* ignore */
  }
  applyAccent(accent);
  window.dispatchEvent(new CustomEvent("accentchange", { detail: accent }));
}

export function applyAccent(accent: Accent = getAccent()): void {
  // "blue" is the default; leave the attribute off so base tokens apply.
  if (accent === "blue") delete document.documentElement.dataset.accent;
  else document.documentElement.dataset.accent = accent;
}

export function initAppearance(): void {
  applyAccent();
}
